var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_1165)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_26_1165)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26_1165",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.504639,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26_1165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5047 10.5L16.3047 14.3L8.70466 14.3L12.5047 10.5Z",
    fill: "#4B4566"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_1165"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.504639,
    width: 24,
    height: 24,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_26_1165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.504639)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownUp);
export default __webpack_public_path__ + "static/media/dropdown-up.36288d9772d8c7d5c45c03d700820e28.svg";
export { ForwardRef as ReactComponent };